import { Database, Clock, Users, Sparkles, Inbox, RefreshCw, type LucideIcon } from "lucide-react";

type Card = { icon: LucideIcon; title: string; body: string };

const DEFAULT: Card[] = [
  { icon: Clock, title: "Reports take too long", body: "Manual updates delay decisions." },
  { icon: Database, title: "Data lives everywhere", body: "Sheets, forms and tools drift out of sync." },
  { icon: Users, title: "Follow-ups get missed", body: "Reminders depend on someone remembering." },
  { icon: Inbox, title: "Forms create more admin", body: "Each submission needs sorting and routing." },
  { icon: RefreshCw, title: "Tools and AI costs keep rising", body: "Tasks balloon and automations become fragile." },
  { icon: Sparkles, title: "AI is not being used safely", body: "Useful AI needs review and accountability." },
];

export default function ProblemCards({ cards }: { cards?: Card[] }) {
  const data = cards ?? DEFAULT;
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {data.map((c) => (
        <article key={c.title} className="card-atk">
          <span className="icon-circle"><c.icon className="h-5 w-5" /></span>
          <h3 className="mt-5 text-[17px] font-semibold text-navy">{c.title}</h3>
          <p className="mt-1.5 text-[14.5px] text-muted-foreground leading-relaxed">{c.body}</p>
        </article>
      ))}
    </div>
  );
}
